import { useTranslation } from "react-i18next";
import { type FreeTextQuestion, type QuestionAnswer } from "../../../../types";
import styles from "./Answers.module.scss";

interface Props {
  question: FreeTextQuestion;
  setSelectedAnswers: (answers: QuestionAnswer[]) => void;
  selectedAnswers: QuestionAnswer[];
}

export const FreeText = (props: Props) => {
  const { setSelectedAnswers, selectedAnswers } = props;
  const { t } = useTranslation("assets");

  const text = selectedAnswers[0];
  const onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSelectedAnswers([e.target.value]);
  };

  return (
    <div className={styles.answers}>
      <textarea
        className={styles.text}
        data-testid="other-text"
        rows={5}
        placeholder={t("common.typeYourResponse")}
        onChange={onChangeText}
        value={text?.toString()}
      />
    </div>
  );
};
